
const onboardingRoutePaths = {
    STEPPER_FORM: {
        path: "/supplier/:id",
        permission: ["PRE_KYC"]
    }
};


export {
    onboardingRoutePaths
};
